module.exports = __webpack_public_path__ + "static/04-6f05c8f69aee29dbeb66099f1d4080b3.jpg";